export default "__VITE_ASSET__D3PRZAT6__"